export const seriesList = [
  {
    id: "star-track",
    title: "星轨之下",
    categoryId: "scifi",
    categoryName: "科幻",
    year: 2025,
    episodes: 8,
    duration: "12 分钟/集",
    tags: ["太空", "硬核科幻", "悬念"],
    score: 9.2,
    popularity: 128500,
    releaseDate: "2025-09-12",
    director: "AI 导演 · 织梦工坊",
    cast: ["林澈", "苏晚", "陆沉"],
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20short%20drama%20poster%2C%20a%20lone%20astronaut%20standing%20before%20a%20glowing%20azure%20planetary%20ring%2C%20deep%20navy%20starfield%20background%2C%20volumetric%20god%20rays%2C%20reflective%20helmet%20visor%2C%20dramatic%20rim%20light%2C%20ultra%20detailed%20moody%20futuristic%20atmosphere%2C%20vertical%20poster%20composition&width=600&height=800&seq=aisd-01-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Epic%20widescreen%20science%20fiction%20film%20still%2C%20astronaut%20silhouetted%20against%20a%20giant%20ringed%20planet%20in%20deep%20navy%20space%2C%20drifting%20station%20lights%2C%20volumetric%20blue%20haze%2C%20cinematic%20wide%20composition%2C%20high%20detail%20futuristic%20atmosphere%2C%20dramatic%20contrast%2C%20no%20text&width=1600&height=900&seq=aisd-01-banner&orientation=landscape",
    description: "一艘失联十二年的深空探测船突然重新发回信号，三名留守工程师必须在四十八小时内决定：迎接它回来，还是让它永远留在星轨之外。全片由 AI 参与分镜与特效生成，用克制的方式探讨人类与未知之间的距离。",
  },
  {
    id: "memory-fold",
    title: "记忆褶皱",
    categoryId: "scifi",
    categoryName: "科幻",
    year: 2025,
    episodes: 6,
    duration: "15 分钟/集",
    tags: ["记忆", "伦理", "反转"],
    score: 8.9,
    popularity: 96200,
    releaseDate: "2025-08-22",
    director: "AI 导演 · 折叠影像",
    cast: ["周岚", "陈屿", "许知"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20sci-fi%20drama%20poster%20of%20a%20translucent%20human%20head%20profile%20made%20of%20layered%20light%20fragments%2C%20memory%20data%20ribbons%20floating%20around%2C%20cool%20teal%20and%20navy%20gradient%20background%2C%20soft%20glow%2C%20minimalist%20futuristic%20design%2C%20high%20detail%20cinematic%20mood&width=600&height=800&seq=aisd-02-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20futuristic%20laboratory%20scene%20with%20floating%20holographic%20memory%20fragments%2C%20a%20scientist%20silhouette%20reaching%20toward%20glowing%20data%20ribbons%2C%20cool%20teal%20and%20deep%20navy%20color%20palette%2C%20volumetric%20light%2C%20cinematic%20sci-fi%20atmosphere%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=aisd-02-banner&orientation=landscape",
    description: "记忆修复师能够替人抹去痛苦片段，却在一次委托中发现了不属于任何人的记忆。当褶皱被一层层抚平，她开始怀疑自己也是被编辑过的人。",
  },
  {
    id: "cyber-teahouse",
    title: "赛博茶馆",
    categoryId: "scifi",
    categoryName: "科幻",
    year: 2024,
    episodes: 10,
    duration: "10 分钟/集",
    tags: ["赛博朋克", "群像", "黑色幽默"],
    score: 8.6,
    popularity: 74300,
    releaseDate: "2024-11-30",
    director: "AI 导演 · 霓虹叙事",
    cast: ["老谢", "阿苔", "小满"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20cyberpunk%20short%20drama%20poster%20of%20a%20tiny%20traditional%20teahouse%20squeezed%20between%20neon%20skyscrapers%2C%20warm%20orange%20lantern%20light%20against%20cool%20blue%20rainy%20night%2C%20holographic%20signs%2C%20cinematic%20noir%20mood%2C%20ultra%20detailed%2C%20moody%20atmosphere&width=600&height=800&seq=aisd-03-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20cyberpunk%20city%20street%20at%20night%20with%20a%20small%20glowing%20teahouse%2C%20warm%20orange%20lantern%20glow%20contrasted%20with%20cool%20blue%20neon%20rain%2C%20flying%20vehicles%20bokeh%2C%20cinematic%20wide%20composition%2C%20highly%20detailed%20futuristic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=aisd-03-banner&orientation=landscape",
    description: "在连空气都要付费的高楼城市里，一家不肯倒闭的旧式茶馆成了底层居民的据点。每一壶茶背后，都是一段被系统判定的失败人生。",
  },
  {
    id: "seventh-mail",
    title: "第七封邮件",
    categoryId: "suspense",
    categoryName: "悬疑",
    year: 2025,
    episodes: 7,
    duration: "14 分钟/集",
    tags: ["密室", "反转", "心理"],
    score: 9.0,
    popularity: 110400,
    releaseDate: "2025-09-28",
    director: "AI 导演 · 暗房计划",
    cast: ["孟寒", "秦书", "杨屹"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20mystery%20thriller%20poster%20of%20a%20dim%20room%20with%20six%20identical%20sealed%20envelopes%20on%20a%20wooden%20table%2C%20a%20seventh%20envelope%20glowing%20faintly%2C%20cold%20blue%20window%20light%2C%20dust%20in%20the%20air%2C%20tense%20minimalist%20composition%2C%20cinematic%20detail&width=600&height=800&seq=aisd-04-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20suspense%20film%20still%20of%20an%20empty%20interrogation%20room%20with%20scattered%20envelopes%20on%20the%20floor%2C%20single%20cold%20light%20source%2C%20long%20shadows%2C%20cool%20blue%20and%20grey%20tones%2C%20cinematic%20wide%20composition%2C%20tense%20atmosphere%2C%20no%20text&width=1600&height=900&seq=aisd-04-banner&orientation=landscape",
    description: "六位互不相识的人在同一时间收到同一封邮件，被邀请到郊外别墅参加一场「游戏」。当第七封邮件出现时，他们才发现真正的规则从未被写下。",
  },
  {
    id: "fog-city-echo",
    title: "雾城回声",
    categoryId: "suspense",
    categoryName: "悬疑",
    year: 2025,
    episodes: 8,
    duration: "13 分钟/集",
    tags: ["犯罪", "追凶", "氛围"],
    score: 8.8,
    popularity: 88700,
    releaseDate: "2025-07-15",
    director: "AI 导演 · 长夜工作室",
    cast: ["沈岸", "白露", "郝强"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20noir%20crime%20poster%20of%20a%20foggy%20city%20street%20at%20dawn%2C%20a%20lone%20detective%20silhouette%20under%20a%20dim%20streetlamp%2C%20heavy%20mist%2C%20muted%20blue%20grey%20palette%20with%20a%20single%20warm%20light%2C%20cinematic%20moody%20composition%2C%20high%20detail&width=600&height=800&seq=aisd-05-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20atmospheric%20crime%20film%20still%20of%20a%20foggy%20riverside%20city%20at%20dusk%2C%20faint%20streetlights%20reflecting%20on%20wet%20roads%2C%20distant%20bridge%20silhouette%2C%20desaturated%20cool%20tones%2C%20cinematic%20wide%20shot%2C%20tense%20quiet%20mood%2C%20no%20text&width=1600&height=900&seq=aisd-05-banner&orientation=landscape",
    description: "一起尘封二十年的旧案因一盘磁带重新启动。退休警察回到终年不散的雾城，要面对的却是当年亲手签下的结案报告。",
  },
  {
    id: "silent-testimony",
    title: "无声证词",
    categoryId: "suspense",
    categoryName: "悬疑",
    year: 2024,
    episodes: 6,
    duration: "16 分钟/集",
    tags: ["法庭", "悬疑", "社会"],
    score: 8.7,
    popularity: 69200,
    releaseDate: "2024-12-18",
    director: "AI 导演 · 证据链",
    cast: ["田野", "林知夏", "吴征"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20legal%20thriller%20poster%20of%20an%20empty%20courtroom%20bench%20with%20a%20single%20folded%20document%2C%20shaft%20of%20light%20through%20blinds%2C%20cold%20blue%20grey%20tones%2C%20tense%20minimalist%20composit%2C%20cinematic%20high%20detail&width=600&height=800&seq=aisd-06-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20courtroom%20film%20still%20with%20silhouettes%20of%20a%20jury%20and%20a%20single%20witness%20stand%20under%20cold%20light%2C%20muted%20blue%20and%20beige%20palette%2C%20solemn%20wide%20composition%2C%20cinematic%20detail%2C%20serious%20atmosphere%2C%20no%20text&width=1600&height=900&seq=aisd-06-banner&orientation=landscape",
    description: "一名聋哑女孩成为唯一的目击者，她的证词却无法被直接采信。年轻律师要用一场没有声音的辩护，撬开所有人的成见。",
  },
  {
    id: "letter-beyond-light",
    title: "光年之外的信",
    categoryId: "drama",
    categoryName: "剧情",
    year: 2025,
    episodes: 5,
    duration: "18 分钟/集",
    tags: ["温情", "科幻外壳", "亲情"],
    score: 9.1,
    popularity: 118900,
    releaseDate: "2025-10-02",
    director: "AI 导演 · 慢速胶片",
    cast: ["安宁", "顾远", "小舟"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20emotional%20drama%20poster%20of%20an%20elderly%20hand%20holding%20a%20weathered%20letter%20against%20a%20starry%20night%20sky%2C%20warm%20golden%20light%20meeting%20cool%20navy%20background%2C%20soft%20grain%2C%20tender%20cinematic%20mood%2C%20high%20detail%2C%20poetic%20composition&width=600&height=800&seq=aisd-07-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20emotional%20film%20still%20of%20a%20person%20sitting%20alone%20on%20a%20hill%20writing%20a%20letter%20under%20a%20vast%20starry%20sky%2C%20warm%20lantern%20glow%20against%20deep%20navy%20night%2C%20soft%20cinematic%20grain%2C%20poetic%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=aisd-07-banner&orientation=landscape",
    description: "一位航天工程师母亲给未出生的女儿录制了二十段语音，却被留在了一颗再也无法返航的卫星上。多年后，女儿用一台旧收音机收到了来自光年之外的问候。",
  },
  {
    id: "homebound-train",
    title: "归途列车",
    categoryId: "drama",
    categoryName: "剧情",
    year: 2025,
    episodes: 6,
    duration: "14 分钟/集",
    tags: ["群像", "春运", "现实"],
    score: 8.9,
    popularity: 91500,
    releaseDate: "2025-06-20",
    director: "AI 导演 · 站台记事",
    cast: ["老赵", "陈默", "丫丫"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20human%20drama%20poster%20of%20a%20crowded%20train%20platform%20at%20night%2C%20warm%20station%20lights%20against%20deep%20blue%20dusk%2C%20silhouette%20of%20a%20man%20carrying%20a%20large%20bag%2C%20nostalgic%20cinematic%20atmosphere%2C%20highly%20detailed%2C%20emotional%20mood&width=600&height=800&seq=aisd-08-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20film%20still%20of%20a%20long%20train%20departing%20a%20small%20station%20at%20dusk%2C%20warm%20window%20lights%20against%20cool%20blue%20evening%20sky%2C%20empty%20platform%2C%20nostalgic%20cinematic%20wide%20composition%2C%20soft%20detail%2C%20no%20text&width=1600&height=900&seq=aisd-08-banner&orientation=landscape",
    description: "一趟横跨三千公里的回家列车，六节车厢装着六个不想回家的人。当列车抵达终点，他们各自要面对的，比旅途更难。",
  },
  {
    id: "24h-store",
    title: "二十四小时便利店",
    categoryId: "drama",
    categoryName: "剧情",
    year: 2024,
    episodes: 12,
    duration: "11 分钟/集",
    tags: ["单元剧", "都市", "治愈"],
    score: 8.5,
    popularity: 65800,
    releaseDate: "2024-10-08",
    director: "AI 导演 · 常温摄影",
    cast: ["店长", "小禾", "夜班客"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20slice%20of%20life%20poster%20of%20a%20glowing%2024%20hour%20convenience%20store%20at%20midnight%2C%20warm%20fluorescent%20light%20spilling%20onto%20a%20dark%20street%2C%20calm%20blue%20night%20sky%2C%20cozy%20cinematic%20atmosphere%2C%20high%20detail%2C%20quiet%20mood&width=600&height=800&seq=aisd-09-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20film%20still%20of%20a%20small%20convenience%20store%20glowing%20on%20an%20empty%20city%20street%20at%203am%2C%20warm%20light%20against%20cool%20blue%20night%2C%20faint%20rain%20reflections%2C%20cinematic%20wide%20composition%2C%20calm%20atmosphere%2C%20no%20text&width=1600&height=900&seq=aisd-09-banner&orientation=landscape",
    description: "凌晨三点还亮着灯的便利店，是这座城市最后的缓冲区。每一集讲述一位深夜来客，以及他买下的那件说不出理由的东西。",
  },
  {
    id: "last-summer",
    title: "最后一个夏天",
    categoryId: "romance",
    categoryName: "爱情",
    year: 2025,
    episodes: 6,
    duration: "15 分钟/集",
    tags: ["青春", "遗憾", "海边"],
    score: 8.8,
    popularity: 84200,
    releaseDate: "2025-08-08",
    director: "AI 导演 · 潮汐影像",
    cast: ["夏至", "江野", "阿念"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20romance%20drama%20poster%20of%20two%20silhouettes%20sitting%20apart%20on%20a%20seaside%20breakwater%20at%20golden%20hour%2C%20warm%20sunset%20against%20cool%20blue%20sea%2C%20soft%20film%20grain%2C%20bittersweet%20cinematic%20mood%2C%20high%20detail%2C%20poetic%20framing&width=600&height=800&seq=aisd-10-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20romance%20film%20still%20of%20a%20quiet%20coastline%20at%20sunset%20with%20two%20distant%20figures%20walking%20apart%2C%20warm%20orange%20horizon%20against%20deep%20blue%20sea%2C%20soft%20cinematic%20grain%2C%20nostalgic%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=aisd-10-banner&orientation=landscape",
    description: "高考后的那个夏天，两个人约好在海边见面，却因为一封没寄出的信错过了整整十年。当他们再次回到同一个海边，故事才刚开始重新计算。",
  },
  {
    id: "letters-hard-to-send",
    title: "锦书难寄",
    categoryId: "costume",
    categoryName: "古装",
    year: 2025,
    episodes: 8,
    duration: "13 分钟/集",
    tags: ["古风", "书信", "家国"],
    score: 8.9,
    popularity: 79600,
    releaseDate: "2025-05-16",
    director: "AI 导演 · 青岚工坊",
    cast: ["沈砚", "柳如是", "裴将军"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20ancient%20Chinese%20costume%20drama%20poster%20of%20a%20scholar%20writing%20by%20candlelight%2C%20ink%20brush%20and%20stacked%20letters%2C%20warm%20amber%20glow%20against%20deep%20indigo%20shadows%2C%20elegant%20oriental%20composition%2C%20highly%20detailed%2C%20cinematic%20mood&width=600&height=800&seq=aisd-11-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20ancient%20Chinese%20film%20still%20of%20a%20lantern%20lit%20study%20room%20at%20night%20with%20scrolls%20and%20an%20ink%20stone%2C%20warm%20amber%20light%20against%20deep%20indigo%20darkness%2C%20elegant%20wide%20composition%2C%20cinematic%20oriental%20atmosphere%2C%20no%20text&width=1600&height=900&seq=aisd-11-banner&orientation=landscape",
    description: "战乱年月，一封家书要走上三个月。守城的书生替全城人代笔写信，却始终不敢写下寄给自己妻子的那一封。",
  },
  {
    id: "changan-twelve",
    title: "长安十二时",
    categoryId: "costume",
    categoryName: "古装",
    year: 2024,
    episodes: 10,
    duration: "12 分钟/集",
    tags: ["唐风", "悬疑", "群像"],
    score: 8.6,
    popularity: 63400,
    releaseDate: "2024-09-26",
    director: "AI 导演 · 坊市志",
    cast: ["李十二", "胡姬", "不良帅"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20Tang%20dynasty%20costume%20drama%20poster%20of%20a%20bustling%20lantern%20lit%20ancient%20city%20gate%20at%20dusk%2C%20warm%20red%20orange%20lanterns%20against%20deep%20blue%20sky%2C%20silhouettes%20of%20horses%20and%20guards%2C%20cinematic%20oriental%20composition%2C%20highly%20detailed&width=600&height=800&seq=aisd-12-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20ancient%20Chinese%20city%20market%20at%20dusk%20with%20rows%20of%20warm%20lanterns%2C%20crowds%20and%20horse%20carriages%2C%20deep%20blue%20evening%20sky%2C%20cinematic%20wide%20composition%2C%20detailed%20oriental%20atmosphere%2C%20no%20text&width=1600&height=900&seq=aisd-12-banner&orientation=landscape",
    description: "长安城的十二个时辰里，一名不良人要在宵禁前找出混入坊市的密探。线索藏在一碗胡辣汤、一盏灯笼和一次擦肩而过里。",
  },
  {
    id: "under-neon",
    title: "霓虹之下",
    categoryId: "urban",
    categoryName: "都市",
    year: 2025,
    episodes: 8,
    duration: "13 分钟/集",
    tags: ["职场", "现实", "群像"],
    score: 8.4,
    popularity: 57900,
    releaseDate: "2025-04-11",
    director: "AI 导演 · 加班日记",
    cast: ["方启", "苏黎", "老王"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20urban%20drama%20poster%20of%20a%20tired%20office%20worker%20looking%20out%20of%20a%20high%20rise%20window%20at%20night%2C%20city%20lights%20blurred%20bokeh%2C%20cool%20blue%20tones%20with%20warm%20interior%20light%2C%20cinematic%20moody%20composition%2C%20high%20detail&width=600&height=800&seq=aisd-13-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20city%20skyline%20at%20night%20seen%20through%20a%20rain%20dotted%20office%20window%2C%20cool%20blue%20bokeh%20lights%2C%20faint%20warm%20desk%20lamp%20reflection%2C%20cinematic%20wide%20composition%2C%20urban%20mood%2C%20no%20text&width=1600&height=900&seq=aisd-13-banner&orientation=landscape",
    description: "一家创业公司的最后一轮融资前夜，五个员工各怀心事地留在办公室。霓虹亮起时，他们要在理想和现实之间做一次选择。",
  },
  {
    id: "boss-gone",
    title: "老板不在的日子",
    categoryId: "comedy",
    categoryName: "喜剧",
    year: 2025,
    episodes: 10,
    duration: "9 分钟/集",
    tags: ["职场喜剧", "脑洞", "解压"],
    score: 8.3,
    popularity: 61300,
    releaseDate: "2025-03-07",
    director: "AI 导演 · 摸鱼小组",
    cast: ["小张", "丽丽", "前台"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20workplace%20comedy%20poster%20of%20an%20empty%20boss%20chair%20in%20a%20bright%20office%2C%20colorful%20sticky%20notes%20everywhere%2C%20playful%20warm%20lighting%2C%20lighthearted%20cinematic%20mood%2C%20vibrant%20detail%2C%20humorous%20composition&width=600&height=800&seq=aisd-14-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20bright%20modern%20office%20scene%20with%20colorful%20sticky%20notes%20and%20paper%20planes%20flying%20across%20empty%20desks%2C%20playful%20warm%20daylight%2C%20lighthearted%20cinematic%20wide%20composition%2C%20cheerful%20atmosphere%2C%20no%20text&width=1600&height=900&seq=aisd-14-banner&orientation=landscape",
    description: "老板出差一周，公司群龙无首。三个人决定「维持运转」，结果把小公司经营成了整栋楼最热闹的地方。",
  },
  {
    id: "alien-roommate",
    title: "外星室友",
    categoryId: "comedy",
    categoryName: "喜剧",
    year: 2024,
    episodes: 12,
    duration: "8 分钟/集",
    tags: ["合租", "科幻喜剧", "萌"],
    score: 8.5,
    popularity: 70500,
    releaseDate: "2024-08-14",
    director: "AI 导演 · 星际合租",
    cast: ["阿光", "小葵", "房东"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20sci-fi%20comedy%20poster%20of%20a%20small%20friendly%20alien%20creature%20in%20a%20shared%20apartment%2C%20warm%20cozy%20living%20room%2C%20playful%20pastel%20lighting%20with%20soft%20blue%20accents%2C%20whimsical%20cinematic%20detail%2C%20funny%20charming%20mood&width=600&height=800&seq=aisd-15-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20cozy%20apartment%20living%20room%20with%20a%20small%20glowing%20alien%20creature%20sitting%20on%20a%20sofa%2C%20warm%20lamps%20and%20soft%20blue%20accents%2C%20whimsical%20cinematic%20wide%20composition%2C%20playful%20charming%20atmosphere%2C%20no%20text&width=1600&height=900&seq=aisd-15-banner&orientation=landscape",
    description: "为了省房租，打工人贴出了一张合租广告，没想到搬进来的是一个不会说地球话、但特别会做家务的外星人。",
  },
  {
    id: "dream-exchange",
    title: "梦境交易所",
    categoryId: "fantasy",
    categoryName: "奇幻",
    year: 2025,
    episodes: 7,
    duration: "14 分钟/集",
    tags: ["奇幻设定", "隐喻", "反转"],
    score: 8.8,
    popularity: 87100,
    releaseDate: "2025-09-05",
    director: "AI 导演 · 睡眠研究所",
    cast: ["程一", "梦商", "阿眠"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20fantasy%20drama%20poster%20of%20a%20surreal%20marketplace%20floating%20among%20clouds%20where%20glowing%20bottled%20dreams%20are%20traded%2C%20deep%20indigo%20sky%20with%20warm%20golden%20lamps%2C%20dreamlike%20painterly%20composition%2C%20highly%20detailed%2C%20magical%20mood&width=600&height=800&seq=aisd-16-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20surreal%20fantasy%20scene%20of%20an%20ethereal%20night%20market%20floating%20among%20clouds%2C%20glowing%20bottles%20of%20dreams%20on%20stalls%2C%20deep%20indigo%20sky%20with%20warm%20golden%20light%2C%20dreamlike%20painterly%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=aisd-16-banner&orientation=landscape",
    description: "在这座城市，好梦是可以买卖的。一个再也做不出梦的人，成了交易所里最抢手的买家，也成了最危险的债务人。",
  },
  {
    id: "kite-and-wind",
    title: "纸鸢与风",
    categoryId: "fantasy",
    categoryName: "奇幻",
    year: 2025,
    episodes: 5,
    duration: "16 分钟/集",
    tags: ["奇幻爱情", "东方美学", "诗意"],
    score: 8.7,
    popularity: 68800,
    releaseDate: "2025-02-21",
    director: "AI 导演 · 纸鸢计划",
    cast: ["阿鸢", "风使", "老匠人"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20oriental%20fantasy%20poster%20of%20a%20glowing%20paper%20kite%20flying%20into%20a%20twilight%20sky%20above%20tiled%20rooftops%2C%20warm%20dandelion%20light%20against%20deep%20blue%20dusk%2C%20poetic%20painterly%20composition%2C%20high%20detail%2C%20ethereal%20mood&width=600&height=800&seq=aisd-17-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20oriental%20fantasy%20scene%20of%20many%20glowing%20paper%20kites%20rising%20above%20traditional%20tiled%20rooftops%20at%20twilight%2C%20warm%20light%20against%20deep%20blue%20sky%2C%20poetic%20painterly%20wide%20composition%2C%20ethereal%20detail%2C%20no%20text&width=1600&height=900&seq=aisd-17-banner&orientation=landscape",
    description: "传说把心愿写在纸鸢上，风会替你送达。一个不会放风筝的姑娘，遇见了掌管人间愿望的风使，却被告知自己的愿望早已过期。",
  },
  {
    id: "beyond-cloud",
    title: "云端彼端",
    categoryId: "animation",
    categoryName: "动画",
    year: 2025,
    episodes: 8,
    duration: "10 分钟/集",
    tags: ["AI动画", "冒险", "成长"],
    score: 8.9,
    popularity: 93400,
    releaseDate: "2025-07-30",
    director: "AI 导演 · 云绘动画",
    cast: ["小云", "布丁", "云鲸"],
    cover: "https://readdy.ai/api/search-image?query=Vertical%20AI%20animation%20poster%20of%20a%20small%20child%20riding%20a%20giant%20friendly%20cloud%20whale%20through%20a%20pastel%20sky%2C%20soft%20gradient%20background%20in%20cream%20and%20light%20blue%2C%20whimsical%20detailed%20illustration%2C%20heartwarming%20cinematic%20composition&width=600&height=800&seq=aisd-18-cover&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Widescreen%20animated%20film%20still%20of%20a%20giant%20fluffy%20cloud%20whale%20swimming%20through%20a%20pastel%20sunset%20sky%20with%20floating%20islands%2C%20soft%20cream%20and%20light%20blue%20palette%2C%20whimsical%20detailed%20illustration%2C%20warm%20cinematic%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=aisd-18-banner&orientation=landscape",
    description: "一个住在云端小镇的孩子，为了找回被风卷走的家，骑上云鲸穿越七重天空。全片由 AI 完成角色与场景生成，讲述关于勇气与告别的小冒险。",
  },
];